import {
  SET_LOADING,
  GET_MONITORING,
  GET_MONITORING_ERROR,
  GET_DUPLICATED_EMAIL,
  GET_MISSING_PAYMENTS,
  GET_PENDING_PAYMENTS,
} from "../types";

const MonitoringReducer = (state, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_MONITORING:
      return {
        ...state,
        monitorings: action.payload.monitorings,
        loading: false,
      };

    case GET_DUPLICATED_EMAIL:
      return {
        ...state,
        duplicateds: action.payload.duplicateds,
        loading: false,
      };

    case GET_MISSING_PAYMENTS:
      return {
        ...state,
        missings: action.payload.missings,
        loading: false,
      };

    case GET_PENDING_PAYMENTS:
      return {
        ...state,
        pendings: action.payload.pendings,
        loading: false,
      };

    case GET_MONITORING_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default MonitoringReducer;